<template>
  <div class="clientes">
    <h1 class="titulo-card fs-4">Provisionamento</h1>
    <div class="form-group card-principal">
      <div class="row">

        <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 mb-3">
          <div class="card text-white bg-primary h-100">
            <div class="card-header">Aguardando autorização</div>
            <div class="card-body text-end">
              <h5 class="card-title">
                <span class="icone float-start">
                  <font-awesome-icon :icon="['fas', 'user-plus']" size="2x" fixed-width class="me-1"/>
                </span>
                <font-awesome-icon v-if="(carregandoContadores)" :icon="['fas', 'spinner']" spin fixed-width class="me-1"/>
                <span v-if="(!carregandoContadores)" v-on:click="navegaParaAguardando()" class="cursor-pointer">
                  {{contadores.discovery}}
                </span>
              </h5>
              <p class="card-text"></p>
            </div>
            <div class="card-footer bg-white">
              <small v-on:click="navegaParaAguardando()" class="cursor-pointer text-dark float-end">
                <font-awesome-icon :icon="['fas', 'eye']" fixed-width class="me-1"/>
                Visualizar
              </small>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 mb-3">
          <div class="card text-white bg-success h-100">
            <div class="card-header">Autorizadas</div>
            <div class="card-body text-end">
              <h5 class="card-title">
                <span class="icone float-start">
                  <font-awesome-icon :icon="['fas', 'plug']" size="2x" fixed-width class="me-1"/>
                </span>
                <font-awesome-icon v-if="(carregandoContadores)" :icon="['fas', 'spinner']" spin fixed-width class="me-1"/>
                <span v-if="(!carregandoContadores)" v-on:click="navegaParaAguardando()" class="cursor-pointer">
                  {{contadores.autorizadas}}
                </span>
              </h5>
              <p class="card-text">online - {{contadores.online}}</p>
            </div>
            <div class="card-footer bg-white">
              <small v-on:click="navegaParaOnus()" class="cursor-pointer text-dark float-end">
                <font-awesome-icon :icon="['fas', 'eye']" fixed-width class="me-1"/>
                Visualizar
              </small>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 mb-3">
          <div class="card text-white bg-secondary h-100 card-disabled">
            <div class="card-header">Offline</div>
            <div class="card-body text-end">
              <h5 class="card-title">
                <span class="icone float-start">
                  <font-awesome-icon :icon="['far', 'times-circle']" size="2x" fixed-width class="me-1"/>
                </span>
                <span v-if="(!carregandoContadores)" v-on:click="navegaParaOffline()" class="cursor-pointer">
                  {{contadores.autorizadas - contadores.online}}
                </span>
              </h5>
              <p class="card-text">desligado - 0 / perdeu sinal - 0</p>
            </div>
            <div class="card-footer bg-white">
              <small v-on:click="navegaParaOffline()" class="cursor-pointer text-dark float-end">
                <font-awesome-icon :icon="['fas', 'eye']" fixed-width class="me-1"/>
                Visualizar
              </small>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 mb-3">
          <div class="card bg-warning h-100 card-disabled">
            <div class="card-header">Sinal baixo</div>
            <div class="card-body text-end">
              <h5 class="card-title">
                <span class="icone float-start">
                  <!--<font-awesome-icon :icon="['fas', 'wave-square']" size="2x" fixed-width class="me-1"/>-->
                  <font-awesome-icon :icon="['fas', 'exclamation-triangle']" size="2x" fixed-width class="me-1"/>
                </span>
                <font-awesome-icon v-if="(carregandoContadores)" :icon="['fas', 'spinner']" spin fixed-width class="me-1"/>
                <span v-if="(!carregandoContadores)" v-on:click="navegaParaSinalBaixo()" class="cursor-pointer">
                  {{contadores.sinal_alerta + contadores.sinal_critico}}
                </span>
              </h5>
              <p class="card-text">alerta - {{contadores.sinal_alerta}} / críticos - {{contadores.sinal_critico}}</p>
            </div>
            <div class="card-footer bg-white">
              <small v-on:click="navegaParaSinalBaixo()" class="cursor-pointer text-dark float-end">
                <font-awesome-icon :icon="['fas', 'eye']" fixed-width class="me-1"/>
                Visualizar
              </small>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import api from '@/modules/api'

export default {
  name: 'ProvisionamentoOnus',

  data() {
    return {
      carregandoContadores: true,
      intervaloAtualizaContadores: undefined,
      contadores: {
        discovery: 0,
        autorizadas: 0,
        online: 0,
        off_motivo_desligado: 0,
        off_motivo_loss: 0,
        sinal_alerta: 0,
        sinal_critico: 0,
      }
    }
  },

  methods: {
    carregaContadores() {
      const apiUrl = `/isp/onu/contadores`;

      api.get(apiUrl).then(res => {
        this.carregandoContadores = false;
        this.contadores = res.data;
      }).catch(() => {
        //
      });
    },

    navegaParaAguardando() {
      this.$router.push({ path: `/provisionamento-onus/aguardando` });
    },

    navegaParaOnus() {
      this.$router.push({ path: `/provisionamento-onus/onus` });
    },

    navegaParaOffline() {
      // this.$router.push({ path: `/provisionamento-onus/onus` });
    },

    navegaParaSinalBaixo() {
      // this.$router.push({ path: `/provisionamento-onus/onus` });
    },

    //TODO: tornar esta função como global
    /**
     * @param {Number} numero
     * @param {Number} zeros
     * @returns {string} Strins com "zeros" à esquerda do número informado
     **/
    strZero(numero, zeros){
        return Array(zeros-String(numero).length+1).join('0') + numero;
    },

    //TODO: tornar esta função como global
    /**
     * @param {Date} data
     * @returns {string} Data no formato YYYY-MM-DD
     **/
    dateTimeToMySQLDateTimeStr(data) {
      const dia = this.strZero(data.getDate(), 2);
      const mes = this.strZero(data.getMonth()+1, 2);
      const hora = this.strZero(data.getHours(), 2);
      const minuto = this.strZero(data.getMinutes(), 2);
      const segundo = this.strZero(data.getSeconds(), 2);

      return `${data.getFullYear()}-${mes}-${dia} ${hora}:${minuto}:${segundo}`;
    },
  },

  created() {
    this.carregaContadores();
    this.intervaloAtualizaContadores = setInterval(this.carregaContadores, 3000);
  },

  destroyed() {
    clearInterval(this.intervaloAtualizaContadores);
  },
}
</script>

<style>
.card-disabled {
  opacity: 0.5;
}
</style>